import { normalizeChar } from './utils.js';

export function createShapeForChar(shapeKeys, defaultViewShape, getSelectedFallbackShape) {
	const normalizedShapeKeys = (shapeKeys || []).map((key) => String(key));
	const availableShapes = new Set(normalizedShapeKeys);

	return function shapeForChar(char) {
		const normalized = normalizeChar(char);
		if (availableShapes.has(normalized)) {
			return normalized;
		}

		const selectedFallbackShape = String(getSelectedFallbackShape() || '');
		if (availableShapes.has(selectedFallbackShape)) {
			return selectedFallbackShape;
		}

		const normalizedDefaultShape = String(defaultViewShape || '');
		if (availableShapes.has(normalizedDefaultShape)) {
			return normalizedDefaultShape;
		}
		if (availableShapes.has('star')) {
			return 'star';
		}
		return normalizedShapeKeys[0] || '';
	};
}
